export const amUserAPI = 'https://lic5xecvprhnpppkdoqkrjbadu.appsync-api.us-east-1.amazonaws.com/graphql';

export const amGuestAPI = "https://ykc424vjzrdhlmpgc6arrkxgxa.appsync-api.us-east-1.amazonaws.com/graphql";

export const GetAppSyncPublicAPIKey = 'https://iimkbxidx6.execute-api.us-east-1.amazonaws.com/Prod/key';

export const getOpportunityStages = 'https://6tielo6zy1.execute-api.us-east-1.amazonaws.com/Prod/opportunity';

